import {
    Box,
    Grid,
    Typography,
    Avatar,
    Stack,
    Chip,
    Button,
    Paper,
    Divider,
    CardContent,
    Card,
    Breadcrumbs,
    Link,
    Rating,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    CardMedia,
    CircularProgress,
    LinearProgress,
    TextField,
    IconButton
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import OceshaLogo from '../../../assets/ocesha_images/ocesha_logo.png';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { ReactComponent as VerifiedTick } from '../../../assets/podcast_monster/verified-tick.svg';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import certificate from '../../../assets/podcast_monster/Certificates.png';
import { ReactComponent as FavIcon } from '../../../assets/podcast_monster/favorite_ico.svg';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import { ReactComponent as CloudDownload } from '../../../assets/podcast_monster/cloud_download_ico.svg';
import { ReactComponent as MobileIco } from '../../../assets/podcast_monster/mobile_ico.svg';
import { ReactComponent as LinkIco } from '../../../assets/podcast_monster/link_ico.svg';
import { ReactComponent as MedalIco } from '../../../assets/podcast_monster/medal_ico.svg';
import { isMobile } from "react-device-detect";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";

// --- New icons for the redesigned sections ---
import BarChartIcon from "@mui/icons-material/BarChart";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";


const interFont = "'Inter', sans-serif";
const cardBg = "#161b22";
const border = "#21262d";
const primary = "#3b82f6";
const primaryLight = "#60a5fa";
const panelBg = "#0d1117";
const SHOW_CERTIFICATE = false;
const SHOW_DIGITAL_TWIN_ASSISTANT = false;

export default function IndividualCoursesPage() {

    const navigate = useNavigate();
    const supportUserid = process.env.REACT_APP_SUPPORT_USER_ID || '';
    const loggedIn = localStorage.getItem('logged_in');
    const location = useLocation();
    // const courseId = location.state?.courseId || null;/* "69a7af122737256b9a854a9c" */
    const courseId = location.state?.courseId || localStorage.getItem("courseId");
    const studentEmail = location.state?.studentEmail || localStorage.getItem("user_email");
    const autoCheckout = location.state?.autoCheckout;

    const params = useParams();
    const profileId = params.profile_id;
    const courseUrlSlug = params.course_url;
    const decodedCourseUrl = courseUrlSlug ? decodeURIComponent(courseUrlSlug) : undefined;


    const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
    const returnDomain = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";
    const [curriculum, setCurriculum] = useState<any[]>([]);
    // const [activeWeekIndex, setActiveWeekIndex] = useState<number | null>(0);
    const [expandedWeeks, setExpandedWeeks] = useState<number[]>([]);
    const [courseImage, setCourseImage] = useState<any>();
    const [loadingCourse, setLoadingCourse] = useState(false);
    const [completeCourseDet, setCompleteCourseDet] = useState<any>();
    const [resolvedCourseId, setResolvedCourseId] = useState<any>(courseId);
    const hasFetched = useRef(false);
    const [loadingCheckout, setLoadingCheckout] = useState(false);
    const [isEnrolled, setIsEnrolled] = useState(false);
    const [reviews, setReviews] = useState<any[]>([]);
    const [avgRating, setAvgRating] = useState(0);
    const [totalReviews, setTotalReviews] = useState(0);
    const [frequentlyBought, setFrequentlyBought] = useState<any[]>([]);
    const [loadingFB, setLoadingFB] = useState(false);
    const [mentor, setMentor] = useState<any>(null);

    // --- Digital Twin Assistant (chat widget) state ---
    const [chatInput, setChatInput] = useState("");
    const [chatMessages, setChatMessages] = useState<{ role: "user" | "assistant"; text: string }[]>([]);
    const [chatLoading, setChatLoading] = useState(false);


    // course content listing icons
    const lessonIcons = [
        <InsertDriveFileOutlinedIcon fontSize="small" />,
        <PlayCircleFilledWhiteOutlinedIcon fontSize="small" />,
        <PlayCircleFilledWhiteOutlinedIcon fontSize="small" />,
        <PlayCircleFilledWhiteOutlinedIcon fontSize="small" />,
        <ContentPasteOutlinedIcon fontSize="small" />,
        <ContentPasteOutlinedIcon fontSize="small" />
    ];

    //course includes icons
    const courseIncludesIco = [
        <PlayCircleOutlineOutlinedIcon fontSize="small" />,
        <CloudDownload fontSize="small" />,
        <MobileIco fontSize="small" />,
        <LinkIco fontSize="small" />,
        <MedalIco fontSize="small" />,
    ];

    // --- New static content blocks for the redesigned sections ---
    // These read from completeCourseDet first (in case your backend already/will send
    // this data), and fall back to sensible generic copy otherwise. Swap the fallback
    // arrays for real content whenever you're ready.

    // Rotating icon set used to pair with each plain-text learning objective below
    const learnIconSet = [
        <GpsFixedOutlinedIcon />,
        <ExtensionOutlinedIcon />,
        <TrendingUpOutlinedIcon />,
        <PsychologyOutlinedIcon />,
        <ShieldOutlinedIcon />,
        <RocketLaunchOutlinedIcon />,
    ];

    // API returns course_learning_objectives (and/or learning_outcomes) as a plain
    // string array — pair each string with a rotating icon for display.
    const learningObjectivesSource =
        completeCourseDet?.course_learning_objectives?.length
            ? completeCourseDet.course_learning_objectives
            : completeCourseDet?.learning_outcomes?.length
                ? completeCourseDet.learning_outcomes
                : null;

    const whatYoullLearn = learningObjectivesSource
        ? learningObjectivesSource.map((text: string, idx: number) => ({
            icon: learnIconSet[idx % learnIconSet.length],
            text,
        }))
        : [
            { icon: <GpsFixedOutlinedIcon />, text: "Understand the core concepts covered in this course" },
            { icon: <ExtensionOutlinedIcon />, text: "Identify real opportunities you can apply this to" },
            { icon: <TrendingUpOutlinedIcon />, text: "Build a practical strategy to implement what you learn" },
            { icon: <PsychologyOutlinedIcon />, text: "Apply the tools and frameworks to your own work" },
            { icon: <ShieldOutlinedIcon />, text: "Evaluate best practices, risks, and ethical considerations" },
            { icon: <RocketLaunchOutlinedIcon />, text: "Drive real results and measurable improvement" },
        ];

    const whoThisIsFor = completeCourseDet?.audience?.length
        ? completeCourseDet.audience
        : [
            "Business owners and entrepreneurs",
            "Strategic leaders and decision makers",
            "Product and innovation managers",
            "Consultants and advisors",
            "Anyone looking to grow using this course's approach",
        ];

    const prerequisitesText =
        completeCourseDet?.prerequisites ||
        "No prior experience required. A basic understanding of the subject is helpful.";

    const byEndOfCourse = completeCourseDet?.outcomes?.length
        ? completeCourseDet.outcomes
        : [
            "Confidently explain and apply what you've learned",
            "Create a practical strategy for your own use case",
            "Identify the right tools and resources to get started",
            "Improve decision-making and day-to-day efficiency",
            "Measure impact and scale what works",
        ];

    const quickAssistantQuestions = [
        `What is ${completeCourseDet?.title || completeCourseDet?.name || "this course"} about?`,
        "How does this course create value for me?",
        "Can you give an example of what I'll build?",
        "What skills will I gain in this course?",
    ];

    const assessmentItems = [
        { icon: <FactCheckOutlinedIcon />, label: "Lesson Knowledge Checks" },
        { icon: <QuizOutlinedIcon />, label: "Module Quizzes" },
        { icon: <AssignmentTurnedInOutlinedIcon />, label: "Final Assessment" },
        { icon: <WorkspacePremiumOutlinedIcon />, label: "Certificate of Completion" },
    ];

    //    useEffect(() => {
    //     if (!courseId) {
    //         toast.error('Something went wrong, Please try again later!');
    //         return;
    //     }

    //     if (hasFetched.current) return;

    //     hasFetched.current = true;

    //     getCourseDetail();
    //     getCourseReviews(); 
    // }, [courseId]);
    useEffect(() => {
        const hasSlug = profileId && decodedCourseUrl;
        if (!courseId && !hasSlug) return;

        getCourseDetail();


    }, [courseId, profileId, decodedCourseUrl]);

    useEffect(() => {
        if (!resolvedCourseId) return;
        getCourseReviews();
        checkEnrolledCourse();
    }, [resolvedCourseId]);
    // const getCourseDetail = async () => {
    //     try {
    //         setLoadingCourse(true);

    //         const res = await axios.get(`${apiUrl}/api/prompts/get_course/${courseId}`);

    //         console.log('individual course response=>', res?.data?.course);
    //         console.log('individual curriculum res=>', res?.data?.course?.curriculum);
    //         setCompleteCourseDet(res?.data?.course);
    //         setCourseImage(res?.data?.course?.image_path_small);
    //         const list = res?.data?.course?.curriculum || [];
    //         setCurriculum(list);
    //         // setActiveWeekIndex(0);
    //         setExpandedWeeks([0]);
    //     } catch (error: any) {
    //         console.log('Error fetching course detail=>', error);
    //         toast.error(error);
    //     } finally {
    //         setLoadingCourse(false);
    //     }
    // };

    const getCourseDetail = async () => {
        try {
            setLoadingCourse(true);

            let res;
            if (profileId && decodedCourseUrl) {
                // New public slug route: resolve by profile + slug
                res = await axios.get(
                    `${apiUrl}/api/prompts/get_course_by_slug/${encodeURIComponent(profileId)}/${encodeURIComponent(decodedCourseUrl)}`
                );
            } else {
                // Existing route: resolve by course ObjectId
                res = await axios.get(`${apiUrl}/api/prompts/get_course/${courseId}`);
            }

            const course = res?.data?.course;

            // console.log('course id =>>', res?.data?.course);

            const resolvedId = res?.data?.course?._id || course?.id || courseId;
            setResolvedCourseId(resolvedId);

            const apiUser = course?.user || {};
            const derivedName =
                apiUser?.name ||
                [apiUser?.first_name, apiUser?.last_name].filter(Boolean).join(" ") ||
                undefined;

            const updatedCourse = {
                ...course,
                user: {
                    ...apiUser,
                    email: apiUser?.email || course?.user_email || "",
                    name: derivedName,
                }
            };

            setCompleteCourseDet(updatedCourse);
            setCourseImage(course?.image_path_small);
            setCurriculum(course?.curriculum || []);
            setExpandedWeeks([0]);

            const email = course?.user_email;
            if (email) {
                getFrequentlyBought(email);
            }
        } catch (error: any) {
            console.log('Error fetching course detail=>', error);
        } finally {
            setLoadingCourse(false);
        }
    };

    const getCourseReviews = async () => {
        try {
            const res = await axios.get(
                `${apiUrl}/api/student/reviews/course/${courseId}`
            );

            console.log("reviews response =>", res.data);

            setReviews(res.data?.reviews || []);
            setAvgRating(res.data?.average_rating || 0);
            setTotalReviews(res.data?.total_reviews || 0);
        } catch (error) {
            console.error("Error fetching reviews =>", error);
        }
    };
    const checkEnrolledCourse = async () => {
        try {
            if (!studentEmail || !resolvedCourseId) return;

            const res = await axios.get(
                `${apiUrl}/api/student/courses/enrolled`,
                {
                    params: {
                        user_email: studentEmail
                    }
                }
            );

            // console.log("enrolled courses =>", res.data);

            const enrolledCourses = res?.data?.courses || [];

            // console.log('enrolled courses res =>>', res?.data?.courses);

            const alreadyEnrolled = enrolledCourses.some(
                (course: any) =>
                    course._id === (courseId || resolvedCourseId) ||
                    course.parent_course_id === (courseId || resolvedCourseId)
            );

            setIsEnrolled(alreadyEnrolled);

        } catch (error) {
            console.error("Error checking enrolled courses =>", error);
        }
    };
    const getFrequentlyBought = async (email: string) => {
        try {
            setLoadingFB(true);

            const res = await axios.get(
                `${apiUrl}/api/prompts/courses/by-user`,
                {
                    params: { user_email: email }
                }
            );

            console.log("frequently bought =>", res.data);

            setFrequentlyBought(res.data?.courses || []);

            const mentorData = res.data?.mentor;

            if (mentorData) {
                setMentor(mentorData);

                const mentorDerivedName =
                    mentorData?.name ||
                    [mentorData?.first_name, mentorData?.last_name].filter(Boolean).join(" ") ||
                    undefined;

                setCompleteCourseDet((prev: any) => ({
                    ...prev,
                    user: {
                        ...prev?.user,
                        ...mentorData,
                        name: mentorDerivedName || prev?.user?.name,
                        email: mentorData.email || prev?.user?.email
                    }
                }));
            }


        } catch (error) {
            console.error("Error fetching frequently bought =>", error);
        } finally {
            setLoadingFB(false);
        }
    };
    const handleAccordionToggle = (index: number) => {
        setExpandedWeeks((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    const handleExpandAll = () => {
        if (expandedWeeks.length === curriculum.length) {
            setExpandedWeeks([]); // collapse all
        } else {
            setExpandedWeeks(curriculum.map((_, i) => i)); // expand all
        }
    };

    const totalSections = curriculum?.length || 0;

    const totalLectures =
        curriculum?.reduce((acc: number, week: any) => {
            return acc + (week?.subtopics?.length || 0);
        }, 0) || 0;

    // Estimated time per module: duration is expressed in weeks (e.g. "12 weeks"),
    // and we assume ~2 hours of study per week. Total course hours are then spread
    // evenly across the modules.


    // const durationWeeksMatch = completeCourseDet?.duration?.match(/\d+/);
    // const durationWeeks = durationWeeksMatch
    //     ? parseInt(durationWeeksMatch[0], 10)
    //     : totalSections || 1;
    // const totalCourseHours = durationWeeks * 2;
    // const estimatedTimePerModule =
    //     totalSections > 0
    //         ? `${(totalCourseHours / totalSections).toFixed(1)} hrs`
    //         : "~1 hour";


    // Parse "lessonLength" (e.g. "Short (5–10 min)", "Medium (10–20 min)",
    // "Long (20–30 min)") into an average number of minutes per lesson.
    // Handles both a regular hyphen and an en-dash between the two numbers,
    // and falls back to a sensible default if the field is missing/unrecognized.
    
    // Parses backend duration strings like "1 hr 10 min", "45 min", "2 hr",
    // "1.5 hr" into total minutes. Returns 0 if it can't parse anything.
    const parseDurationToMinutes = (raw?: string): number => {
        if (!raw || typeof raw !== "string") return 0;

        const str = raw.toLowerCase();
        let totalMinutes = 0;

        const hrMatch = str.match(/(\d+(?:\.\d+)?)\s*(?:hr|hour)/);
        const minMatch = str.match(/(\d+(?:\.\d+)?)\s*min/);

        if (hrMatch) totalMinutes += parseFloat(hrMatch[1]) * 60;
        if (minMatch) totalMinutes += parseFloat(minMatch[1]);

        return totalMinutes;
    };

    const formatMinutes = (totalMinutes: number): string => {
        const rounded = Math.round(totalMinutes);
        if (!rounded) return "";
        if (rounded < 60) return `${rounded} min`;
        const hrs = Math.floor(rounded / 60);
        const mins = rounded % 60;
        return mins > 0 ? `${hrs} hr ${mins} min` : `${hrs} hr`;
    };

    // Parse "lessonLength" (e.g. "Short (5–10 min)", "Medium (10–20 min)",
    // "Long (20–30 min)") into an average number of minutes per lesson.
    // Used only as a fallback when curriculum weeks don't carry their own
    // `duration` value yet.
    const parseAvgLessonMinutes = (lessonLength?: string): number => {
        if (!lessonLength) return 15; // default: Medium (10–20 min) midpoint

        const numbers = lessonLength.match(/\d+/g);
        if (!numbers || numbers.length === 0) return 15;

        if (numbers.length === 1) {
            return parseInt(numbers[0], 10);
        }

        const low = parseInt(numbers[0], 10);
        const high = parseInt(numbers[1], 10);
        return (low + high) / 2;
    };

    const lessonLengthRaw =
        completeCourseDet?.customization?.lessonLength ||
        completeCourseDet?.lessonLength;

    const avgMinutesPerLesson = parseAvgLessonMinutes(lessonLengthRaw);

    // Real total course duration — summed from each week's own `duration`
    // field (e.g. "1 hr 10 min"), which is the authoritative value from the
    // backend. Falls back to the lesson-length estimate for any week missing it.
    const computedCourseDurationMinutes = curriculum.reduce((sum, week) => {
        const parsed = parseDurationToMinutes(week?.duration);
        return sum + (parsed > 0 ? parsed : (week?.subtopics?.length || 0) * avgMinutesPerLesson);
    }, 0);

    // Total Duration — never falls back to completeCourseDet.duration
    // ("X Weeks"), since that's the course length, not actual content time.
    const displayDuration =
        computedCourseDurationMinutes > 0
            ? formatMinutes(computedCourseDurationMinutes)
            : `${totalSections} Weeks`;

    const estimatedTimePerModule =
        totalSections > 0 && computedCourseDurationMinutes > 0
            ? formatMinutes(computedCourseDurationMinutes / totalSections)
            : "~1 hour";
            

    // const handleBuyNow = async () => {
    //     try {
    //         setLoadingCheckout(true);

    //         const response = await axios.post(
    //             `${apiUrl}/api/subscription/create-course-checkout-session?student_email=${studentEmail}&course_id=${courseId}&return_domain=${returnDomain}`
    //         );

    //         if (response?.data?.checkout_url) {
    //             window.location.href = response.data.checkout_url;
    //         }

    //     } catch (error) {
    //         console.error("Checkout error:", error);
    //     } finally {
    //         setLoadingCheckout(false);
    //     }
    // };
    const handleBuyNow = async () => {
        try {

            setLoadingCheckout(true);

            const response = await axios.post(
                `${apiUrl}/api/subscription/create-course-checkout-session`,
                null,
                {
                    params: {
                        student_email: studentEmail,
                        course_id: courseId || resolvedCourseId,
                        return_domain: returnDomain,
                    },
                }
            );

            console.log("CHECKOUT =>", response.data);

            if (response?.data?.checkout_url) {
                window.location.href =
                    response.data.checkout_url;
            }

        } catch (error: any) {

            console.error(
                "CHECKOUT ERROR =>",
                error?.response?.data || error
            );

            toast.error(
                error?.response?.data?.detail ||
                "Checkout failed"
            );

        } finally {

            setLoadingCheckout(false);
        }
    };

    useEffect(() => {
        if (
            autoCheckout &&
            studentEmail &&
            resolvedCourseId &&
            completeCourseDet?.price_type !== "free"
        ) {
            handleBuyNow();
        }
    }, [autoCheckout, studentEmail, resolvedCourseId, completeCourseDet?.price_type]);

    const createCourseSlug = (
        title: string,
        id: string
    ) => {
        const slug = title
            ?.toLowerCase()
            ?.trim()
            ?.replace(/[^a-z0-9\s-]/g, "")
            ?.replace(/\s+/g, "-");

        return `${slug}-${id}`;
    };

    // Public profile URL for the course instructor, e.g.
    // https://yourapp.com/profile/saravanan-18819
    const profileIdentifier = completeCourseDet?.user?.profile_id || completeCourseDet?.user?.id;
    const profileUrl = profileIdentifier
        ? `${window.location.origin}/profile/${encodeURIComponent(profileIdentifier)}`
        : null;

    const handleViewProfile = () => {
        if (completeCourseDet?.user?.id) {
            localStorage.setItem("creatorId", completeCourseDet.user.id);
            localStorage.setItem("creatorName", completeCourseDet.user.name);
        }

        localStorage.setItem("activeItem", "authority");

        if (profileIdentifier) {
            const profileUrl = `/profile/${encodeURIComponent(profileIdentifier)}`;

            window.open(profileUrl, "_blank", "noopener,noreferrer");
        } else {
            window.open("/codegenie/generated-blogs", "_blank", "noopener,noreferrer");
        }
    };

    // --- Digital Twin Assistant handlers (client-side stub — wire this up to your
    // real assistant/chat endpoint whenever it's ready) ---
    const handleQuickQuestion = (question: string) => {
        setChatInput(question);
    };

    const handleSendChat = async () => {
        const message = chatInput.trim();
        if (!message) return;

        setChatMessages((prev) => [...prev, { role: "user", text: message }]);
        setChatInput("");
        setChatLoading(true);

        try {
            // TODO: replace with a real call to your AI Digital Twin / assistant endpoint, e.g.
            // const res = await axios.post(`${apiUrl}/api/courses/${resolvedCourseId}/assistant`, { message });
            // const reply = res?.data?.reply || "...";
            const reply =
                "Thanks for the question! Once this is connected to the assistant endpoint, you'll get a real answer here.";
            setChatMessages((prev) => [...prev, { role: "assistant", text: reply }]);
        } catch (error) {
            console.error("Assistant chat error =>", error);
        } finally {
            setChatLoading(false);
        }
    };

    return (
        <>
            {/* Header */}
            <div className="container">
                <div className="row">
                    <nav className="navbar navbar-expand-md">
                        <div className="container-fluid">
                            <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"} style={{ width: '5%' }}>
                                <img src={OceshaLogo} className="img-fluid" alt="" style={{ width: '95%' }} />
                            </a>
                            <button
                                className="navbar-toggler"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#navbarScroll"
                                aria-controls="navbarScroll"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="">
                                    <i className="bi bi-list text-white" />
                                </span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarScroll">
                                <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll ms-md-5 gap-4">

                                </ul>
                                {/* {loggedIn === 'true' ?
                                    <div className="d-flex gap-4" role="search">
                                        <Button
                                            startIcon={<NavigateBeforeIcon />}
                                            onClick={() => window.close()}
                                            sx={{
                                                fontFamily: interFont,
                                                fontWeight: 500,
                                                fontSize: 13,
                                                textTransform: "none",
                                                color: "#9ca3af",
                                                mb: 2,
                                                px: 0,
                                                minWidth: "auto",
                                                "&:hover": { color: primaryLight, background: "transparent" },
                                            }}
                                        >
                                            Close
                                        </Button>
                                    </div>
                                    :
                                    <div className="d-flex gap-4" role="search">
                                        <button className="btn btn-outline-primary px-3"
                                            onClick={() => {
                                                if (localStorage.getItem('logged_in') === 'true') {
                                                    localStorage.setItem('activeItem', 'blogs');
                                                    navigate('/codegenie/generated-blogs');
                                                } else {
                                                    navigate("/signin");
                                                }
                                            }}>Sign In</button>
                                        <button className="button_leniar px-3" type="submit" onClick={() => navigate("/signup")}>
                                            Sign Up
                                        </button>
                                    </div>} */}
                            </div>
                        </div>
                    </nav>
                    <Divider />
                </div>
            </div>
            {/*  */}

            < Box className="overlay-container" sx={{ pr: 10, pl: 10, minHeight: "100vh" }
            }>
                <Box
                    sx={{
                        minHeight: "100vh",
                        color: "#e5e7eb",
                        px: { xs: 2, md: 6 },
                        py: 4,
                        fontFamily: interFont,
                    }}
                >
                    {/* <Button
                            startIcon={<NavigateBeforeIcon />}
                            onClick={() => window.close()}
                            sx={{
                                fontFamily: interFont,
                                fontWeight: 500,
                                fontSize: 13,
                                textTransform: "none",
                                color: "#9ca3af",
                                mb: 2,
                                px: 0,
                                minWidth: "auto",
                                "&:hover": { color: primaryLight, background: "transparent" },
                            }}
                        >
                            Close
                        </Button> */}
                    <Grid container spacing={4}>
                        {/* LEFT CONTENT */}
                        <Grid item xs={12} md={8}>
                            <Stack spacing={3}>
                                {/* Breadcrumb */}
                                {/* <Breadcrumbs separator={
                                    <NavigateNextIcon fontSize="small" color="primary" />
                                } sx={{ fontSize: 13 }}>
                                    <Link underline="none" color="primary">
                                        Home
                                    </Link>
                                    <Link underline="none" color="primary">
                                        Courses
                                    </Link>
                                    <Typography color="primary">Entrepreneur</Typography>
                                </Breadcrumbs> */}

                                {/* Title */}
                                <Box>
                                    <Typography variant="h4" fontWeight={700} color="#e5e7eb" fontFamily={interFont} letterSpacing="-0.02em">
                                        {completeCourseDet?.title || completeCourseDet?.name}
                                    </Typography>

                                    <Typography
                                        sx={{ mt: 0.5, color: "#6b7280", fontSize: 14, fontFamily: interFont }}
                                    >
                                        Created by{" "}
                                        <Box
                                            component="span"
                                            color={primary}
                                            sx={{
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    opacity: 0.8
                                                }
                                            }}
                                            onClick={handleViewProfile}
                                        >
                                            {completeCourseDet?.user?.first_name + " " + completeCourseDet?.user?.last_name || 'Unknown'}
                                        </Box>
                                    </Typography>

                                    <Stack direction="row" spacing={1} alignItems="center" mt={4}>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                px: 1,
                                                py: 0.3,
                                                border: "1px solid #30363d",
                                                borderRadius: "6px",
                                                background: "#0d1117",
                                            }}
                                        >
                                            <Rating size="small" value={completeCourseDet?.average_rating || 0} precision={0.1} readOnly />
                                            <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                {completeCourseDet?.average_rating || 0}
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                px: 1,
                                                py: 0.3,
                                                border: "1px solid #30363d",
                                                borderRadius: "6px",
                                                background: "#0d1117",
                                            }}
                                        >
                                            <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                {completeCourseDet?.total_reviews || 0}  ratings
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                px: 1,
                                                py: 0.3,
                                                border: "1px solid #30363d",
                                                borderRadius: "6px",
                                                background: "#0d1117",
                                            }}
                                        >
                                            <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                {completeCourseDet?.enrolled_students || 0}  students
                                            </Typography>
                                        </Box>
                                    </Stack>

                                    {/* NEW: Course meta row (level / modules / lessons / duration) */}
                                    <Stack
                                        direction="row"
                                        spacing={{ xs: 2, sm: 4 }}
                                        flexWrap="wrap"
                                        alignItems="center"
                                        mt={2.5}
                                        rowGap={1}
                                    >
                                        <Stack direction="row" spacing={0.7} alignItems="center">
                                            <BarChartIcon sx={{ fontSize: 18, color: primary }} />
                                            <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                {completeCourseDet?.level || "Intermediate"} Level
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={0.7} alignItems="center">
                                            <MenuBookOutlinedIcon sx={{ fontSize: 18, color: primary }} />
                                            <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                {totalSections} Modules
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={0.7} alignItems="center">
                                            <DescriptionOutlinedIcon sx={{ fontSize: 18, color: primary }} />
                                            <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                {totalLectures} Lessons
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={0.7} alignItems="center">
                                            <AccessTimeOutlinedIcon sx={{ fontSize: 18, color: primary }} />
                                            <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                {displayDuration}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </Box>

                                {/* Description */}
                                <Typography sx={{ color: "#9ca3af", maxWidth: 720, fontFamily: interFont, lineHeight: 1.7, fontSize: 15 }}>
                                    {/* Overcoming entrepreneurial challenges requires a mix of strategic
                                    planning, psychological resilience, and practical resource
                                    management. Below is a short description of the most common
                                    hurdles and how to navigate them effectively. */}
                                    {completeCourseDet?.description}
                                </Typography>

                                {/* What's included */}
                                <Card
                                    sx={{
                                        background: '#161b22',
                                        border: `1px solid ${border}`,
                                        borderRadius: 2
                                    }}
                                >
                                    <CardContent>
                                        <Typography fontWeight={700} mb={2} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                            What’s Included
                                        </Typography>

                                        <Grid container spacing={2}>
                                            {[
                                                "Practical techniques to improve your coaching effectiveness",
                                                "Real-world scenarios and case studies",
                                                "Strategies for goal-setting, feedback, and client accountability"
                                            ].map((v) => (
                                                <Grid item xs={12} md={6} key={v}>
                                                    <Typography
                                                        sx={{ color: "#9ca3af", fontSize: 14, textAlign: 'left' }}
                                                    >
                                                        <VerifiedTick /> {v}
                                                    </Typography>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </CardContent>
                                </Card>

                                {/* NEW: What You'll Learn */}
                                <Box>
                                    <Typography fontWeight={700} mb={2} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                        What You'll Learn
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {whatYoullLearn.map((item: any, idx: number) => (
                                            <Grid item xs={6} sm={4} key={idx}>
                                                <Paper
                                                    elevation={0}
                                                    sx={{
                                                        background: cardBg,
                                                        border: `1px solid ${border}`,
                                                        borderRadius: "10px",
                                                        p: 2,
                                                        height: "100%",
                                                        textAlign: "center",
                                                        transition: "border-color 0.2s",
                                                        "&:hover": { borderColor: primary },
                                                    }}
                                                >
                                                    <Box sx={{ color: primary, display: "flex", justifyContent: "center", mb: 1 }}>
                                                        {item.icon}
                                                    </Box>
                                                    <Typography fontSize={12.5} color="#9ca3af" fontFamily={interFont} lineHeight={1.5}>
                                                        {item.text}
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>

                                {/* NEW: Who This Course Is For */}
                                <Card sx={{ background: cardBg, border: `1px solid ${border}`, borderRadius: 2 }}>
                                    <CardContent>
                                        <Stack direction="row" spacing={1.2} alignItems="flex-start">
                                            <GroupsOutlinedIcon sx={{ color: primary, mt: 0.3 }} />
                                            <Box>
                                                <Typography fontWeight={700} mb={1} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                                    Who This Course Is For
                                                </Typography>
                                                <Stack spacing={0.6}>
                                                    {whoThisIsFor.map((v: string, idx: number) => (
                                                        <Typography key={idx} fontSize={13.5} color="#9ca3af" fontFamily={interFont}>
                                                            • {v}
                                                        </Typography>
                                                    ))}
                                                </Stack>
                                            </Box>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                {/* NEW: Prerequisites */}
                                <Card sx={{ background: cardBg, border: `1px solid ${border}`, borderRadius: 2 }}>
                                    <CardContent>
                                        <Stack direction="row" spacing={1.2} alignItems="flex-start">
                                            <CheckCircleOutlineOutlinedIcon sx={{ color: primary, mt: 0.3 }} />
                                            <Box>
                                                <Typography fontWeight={700} mb={0.5} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                                    Prerequisites
                                                </Typography>
                                                <Typography fontSize={13.5} color="#9ca3af" fontFamily={interFont}>
                                                    {prerequisitesText}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                {/* NEW: By the End of This Course */}
                                <Card sx={{ background: cardBg, border: `1px solid ${border}`, borderRadius: 2 }}>
                                    <CardContent>
                                        <Stack direction="row" spacing={1.2} alignItems="flex-start">
                                            <EmojiEventsOutlinedIcon sx={{ color: primary, mt: 0.3 }} />
                                            <Box>
                                                <Typography fontWeight={700} mb={1} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                                    By the End of This Course, You Will Be Able To
                                                </Typography>
                                                <Stack spacing={0.6}>
                                                    {byEndOfCourse.map((v: string, idx: number) => (
                                                        <Typography key={idx} fontSize={13.5} color="#9ca3af" fontFamily={interFont}>
                                                            • {v}
                                                        </Typography>
                                                    ))}
                                                </Stack>
                                            </Box>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                {/* NEW: Interactive Learning with Your AI Digital Twin (inline card) */}
                                <Card sx={{ background: cardBg, border: `1px solid ${border}`, borderRadius: 2 }}>
                                    <CardContent>
                                        <Stack direction="row" spacing={1.2} alignItems="flex-start">
                                            <ChatBubbleOutlineOutlinedIcon sx={{ color: primary, mt: 0.3 }} />
                                            <Box>
                                                <Typography fontWeight={700} mb={0.5} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                                    Interactive Learning with Your AI Digital Twin
                                                </Typography>
                                                <Typography fontSize={13.5} color="#9ca3af" fontFamily={interFont} mb={1.5}>
                                                    Learn in an interactive environment guided by the instructor's AI Digital Twin.
                                                    Ask questions, get personalized explanations, explore examples, and receive
                                                    support in your preferred language — anytime, anywhere.
                                                </Typography>
                                                <Stack direction="row" spacing={1} flexWrap="wrap" rowGap={1}>
                                                    {["Ask Anything", "Get Clarifications", "Go Deeper", "Any Language"].map((label) => (
                                                        <Chip
                                                            key={label}
                                                            label={label}
                                                            size="small"
                                                            sx={{
                                                                background: panelBg,
                                                                border: `1px solid ${border}`,
                                                                color: "#9ca3af",
                                                                fontFamily: interFont,
                                                                fontSize: 12,
                                                            }}
                                                        />
                                                    ))}
                                                </Stack>
                                            </Box>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                {/* Course contents */}
                                <Box>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        mb={1}
                                    >
                                        <Typography fontWeight={600}>
                                            Course contents
                                        </Typography>
                                    </Stack>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        mb={1}
                                    >
                                        <Typography
                                            fontSize={13}
                                            sx={{ cursor: "pointer", color: '#888888', fontFamily: interFont }}
                                        >
                                            {totalSections} Modules • {totalLectures} Lessons {/* • 04h 33m total length */}
                                        </Typography>

                                        {!isMobile && (<Typography
                                            color={primary}
                                            fontSize={13}
                                            sx={{ cursor: "pointer", textDecoration: 'underline' }}
                                            onClick={handleExpandAll}
                                        >
                                            {/* Expand all sections */}
                                            {expandedWeeks.length === curriculum.length
                                                ? "Collapse all sections"
                                                : "Expand all sections"}
                                        </Typography>)}
                                    </Stack>

                                    {isMobile && (<Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        mb={1}
                                    >
                                        <Typography
                                            color={primary}
                                            fontSize={13}
                                            sx={{ cursor: "pointer", textDecoration: 'underline' }}
                                        >
                                            Expand all sections
                                        </Typography>
                                    </Stack>)}

                                    {curriculum.map((weekItem: any, i: number) => (
                                        <Accordion
                                            key={i}
                                            // expanded={activeWeekIndex === i}
                                            expanded={expandedWeeks.includes(i)}
                                            /* onChange={() =>
                                                setActiveWeekIndex(activeWeekIndex === i ? null : i)
                                            } */
                                            onChange={() => handleAccordionToggle(i)}
                                            disableGutters
                                            sx={{
                                                background: "#161b22",
                                                border: `1px solid ${border}`,
                                                mb: 1,
                                                color: "#e5e7eb",
                                                "&:before": { display: "none" },
                                                borderRadius: "10px",
                                                boxShadow: "none",
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={null}
                                                sx={{ px: 2 }}
                                            >
                                                {/* LEFT */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        flex: 1,
                                                    }}
                                                >
                                                    <ExpandMoreIcon
                                                        sx={{
                                                            fontSize: 20,
                                                            transition: "transform 0.2s",
                                                            transform:
                                                                /* activeWeekIndex === i */
                                                                expandedWeeks.includes(i)
                                                                    ? "rotate(180deg)"
                                                                    : "rotate(0deg)",
                                                        }}
                                                    />

                                                    <Typography fontSize={14} fontWeight={500}>
                                                        Module {weekItem.week} - {weekItem.title}
                                                    </Typography>
                                                </Box>

                                                {/* RIGHT loader */}
                                                {/* <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <CircularProgress
                                                        size={16}
                                                        thickness={5}
                                                        sx={{ color: "#1e88e5" }}
                                                    />
                                                </Box> */}
                                            </AccordionSummary>

                                            {/* SUBTOPICS */}
                                            <AccordionDetails
                                                sx={{
                                                    pl: 10,
                                                    pr: 2,
                                                    pt: 0.5,
                                                }}
                                            >
                                                <Stack spacing={2.5}>
                                                    {weekItem.subtopics?.map((topic: any, index: number) => (
                                                        <Stack
                                                            key={index}
                                                            direction="row"
                                                            spacing={1.2}
                                                            alignItems="center"
                                                        >
                                                            <Box
                                                                sx={{
                                                                    minWidth: 20,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    color: "#3b82f6",
                                                                }}
                                                            >
                                                                {lessonIcons[index] || lessonIcons[0]}
                                                            </Box>

                                                            <Typography fontSize={15} sx={{ color: "#d1d5db" }}>
                                                                {typeof topic === "string" ? topic : topic?.lesson_title || topic?.title || ""}
                                                            </Typography>
                                                        </Stack>
                                                    ))}
                                                </Stack>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Box>

                                {/* NEW: Assessments & Certification */}
                                <Box>
                                    <Typography fontWeight={700} mb={2} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                        Assessments & Certification
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {assessmentItems.map((item, idx) => (
                                            <Grid item xs={6} sm={3} key={idx}>
                                                <Paper
                                                    elevation={0}
                                                    sx={{
                                                        background: cardBg,
                                                        border: `1px solid ${border}`,
                                                        borderRadius: "10px",
                                                        p: 2,
                                                        textAlign: "center",
                                                        height: "100%",
                                                    }}
                                                >
                                                    <Box sx={{ color: primary, display: "flex", justifyContent: "center", mb: 1 }}>
                                                        {item.icon}
                                                    </Box>
                                                    <Typography fontSize={12.5} color="#9ca3af" fontFamily={interFont}>
                                                        {item.label}
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>

                                {/* Certificate */}
                                {/* <Box>
                                    <Typography fontWeight={700} mb={1} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                        Certificate of Completion
                                    </Typography>

                                    <Card
                                        sx={{
                                            background: '#161b22',
                                            border: `1px solid ${border}`,
                                            borderRadius: 4,
                                            overflow: "hidden",
                                            // maxWidth: 560,
                                            paddingTop: 6,
                                            paddingBottom: 6,
                                            paddingRight: 4,
                                            paddingLeft: 4
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            // height="260"
                                            image={certificate}
                                        />
                                    </Card>
                                </Box> */}

                                {/* Testimonials */}
                                <Box>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        mb={2}
                                    >
                                        <Typography fontWeight={700} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                            Testimonials
                                        </Typography>
                                    </Stack>

                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        mb={2}
                                    >
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            spacing={0.8}
                                            sx={{ color: "#6b7280", cursor: "pointer" }}
                                        >

                                            <Stack direction="row" alignItems="center" spacing={0.8}>
                                                <Typography fontSize={13}>
                                                    {completeCourseDet?.enrolled_students || 0} students
                                                </Typography>

                                                <Typography fontSize={13}>•</Typography>

                                                <Typography fontSize={13}>
                                                    {totalReviews} ratings
                                                </Typography>

                                                <Typography fontSize={13}>•</Typography>

                                                <Rating
                                                    size="small"
                                                    value={avgRating}
                                                    precision={0.1}
                                                    readOnly
                                                />

                                                <Typography fontSize={13}>
                                                    {avgRating}
                                                </Typography>
                                            </Stack>
                                        </Stack>

                                        {!isMobile && (<Typography color={primary} fontSize={13} sx={{ textDecoration: 'underline' }}>
                                            Read all Testimonials
                                        </Typography>)}
                                    </Stack>

                                    {isMobile && (<Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        mb={2}
                                    >
                                        <Typography color={primary} fontSize={13} sx={{ textDecoration: 'underline' }}>
                                            Read all Testimonials
                                        </Typography>
                                    </Stack>)}

                                    <Stack spacing={2}>
                                        {reviews.length > 0 ? (
                                            reviews.map((review: any) => (
                                                <Paper
                                                    key={review._id}
                                                    elevation={0}
                                                    sx={{
                                                        background: cardBg,
                                                        border: `1px solid ${border}`,
                                                        borderRadius: "12px",
                                                        transition: "box-shadow 0.2s, border-color 0.2s",
                                                        "&:hover": { borderColor: "#3b82f6", boxShadow: "0 4px 16px rgba(59,130,246,0.12)" },
                                                    }}
                                                >
                                                    <CardContent>
                                                        <Stack spacing={1}>
                                                            <Stack direction="row" spacing={2} alignItems="center">
                                                                <Avatar sx={{ bgcolor: "#3b82f6", width: 38, height: 38, fontSize: 14, fontWeight: 700 }}>
                                                                    {review.student_name?.charAt(0)?.toUpperCase()}
                                                                </Avatar>
                                                                <Box>
                                                                    <Typography fontSize={14} fontWeight={600} color="#e5e7eb" fontFamily={interFont}>
                                                                        {review.student_name}
                                                                    </Typography>
                                                                    <Typography fontSize={12} color="#6b7280" fontFamily={interFont}>
                                                                        Student
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>

                                                            <Typography fontSize={13} fontFamily={interFont} sx={{ color: "#9ca3af", lineHeight: 1.65 }}>
                                                                {review.comment}
                                                            </Typography>

                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                <Rating
                                                                    value={review.rating}
                                                                    precision={0.1}
                                                                    size="small"
                                                                    readOnly
                                                                />
                                                                <Typography fontSize={12} fontFamily={interFont} color="#9ca3af">
                                                                    {review.rating}
                                                                </Typography>
                                                            </Box>
                                                        </Stack>
                                                    </CardContent>
                                                </Paper>
                                            ))
                                        ) : (
                                            <Typography color="#6b7280" fontFamily={interFont}>No reviews yet</Typography>
                                        )}
                                    </Stack>
                                </Box>

                                {/* Frequently bought */}
                                {/* <Box>
                                    <Typography fontWeight={700} mb={2} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                        Frequently Bought Together
                                    </Typography>

                                    <Grid container spacing={3} alignItems="stretch">
                                        {loadingFB ? (
                                            <CircularProgress sx={{ color: "#3b82f6", ml: 3, mt: 2 }} />
                                        ) : frequentlyBought.length > 0 ? (
                                            frequentlyBought.map((c: any, idx: number) => (
                                                <Grid item xs={12} sm={6} md={6} key={c.id} sx={{ display: "flex" }}>
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            background: cardBg,
                                                            border: `1px solid ${border}`,
                                                            borderRadius: "12px",
                                                            width: "100%",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            overflow: "hidden",
                                                            transition: "box-shadow 0.2s, border-color 0.2s",
                                                            "&:hover": { borderColor: "#3b82f6", boxShadow: "0 4px 20px rgba(59,130,246,0.15)" },
                                                        }}
                                                    >
                                                        <Box sx={{ position: "relative", p: "10px" }}>
                                                            <CardMedia
                                                                component="img"
                                                                image={c.image_path_small}
                                                                sx={{
                                                                    borderRadius: "8px",
                                                                    height: 180,
                                                                    width: "100%",
                                                                    objectFit: "cover",
                                                                }}
                                                            />
                                                        </Box>

                                                        <CardContent sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                                                            <Typography fontSize={14} fontWeight={700} color="#e5e7eb" fontFamily={interFont} letterSpacing="-0.01em">
                                                                {c.title}
                                                            </Typography>

                                                            <Typography fontSize={12} color="#6b7280" fontFamily={interFont} mt={0.25}>
                                                                by {mentor?.name}
                                                            </Typography>

                                                            <Typography fontSize={13} mt={1} mb={1} fontFamily={interFont} sx={{ color: "#9ca3af", lineHeight: 1.6, flex: 1 }}>
                                                                {c.description}
                                                            </Typography>

                                              
                                                            <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                                                                <Box sx={{
                                                                    display: "flex", alignItems: "center", gap: 0.5,
                                                                    px: 0.8, py: "2px",
                                                                    borderRadius: "6px",
                                                                    border: `1px solid ${border}`,
                                                                    background: "#0d1117",
                                                                }}>
                                                                    <Rating size="small" value={c.average_rating} precision={0.1} readOnly />
                                                                    <Typography fontSize={12} fontFamily={interFont} color="#9ca3af">
                                                                        {c.average_rating}
                                                                    </Typography>
                                                                </Box>

                                                                <Typography fontSize={12} color="#6b7280" fontFamily={interFont}>
                                                                    {c.review_count} ratings
                                                                </Typography>
                                                            </Stack>

                                                       
                                                            <Stack direction="row" alignItems="center" spacing={1} mt={1}>
                                                                <Typography fontWeight={700} fontSize={15} color="#e5e7eb" fontFamily={interFont} letterSpacing="-0.01em">
                                                                    ${c.suggested_price}
                                                                </Typography>
                                                            </Stack>

                                                          
                                                            <Button
                                                                fullWidth
                                                                variant="contained"
                                                                disableElevation
                                                                sx={{
                                                                    mt: 1.5,
                                                                    textTransform: "none",
                                                                    fontFamily: interFont,
                                                                    fontWeight: 600,
                                                                    fontSize: 13,
                                                                    borderRadius: "8px",
                                                                    background: "#3b82f6",
                                                                    "&:hover": { background: "#2563eb" },
                                                                }}
                                                                onClick={() => {
                                                                    const id = c.id || c._id;
                                                                    localStorage.setItem("courseId", id);
                                                                    navigate("/codegenie/individual-course", {
                                                                        state: { courseId: id }
                                                                    });
                                                                }}
                                                            >
                                                                View Course
                                                            </Button>
                                                        </CardContent>
                                                    </Paper>
                                                </Grid>
                                            ))
                                        ) : (
                                            <Typography sx={{ color: "#6b7280", mt: "12px", ml: "25px", fontFamily: interFont }}>
                                                No recommendations available
                                            </Typography>
                                        )}


                                    </Grid>
                                </Box> */}
                            </Stack>
                        </Grid>

                        {/* RIGHT SIDEBAR */}
                        <Grid item xs={12} md={4}>
                            <Stack spacing={2.5} sx={{ position: "sticky", top: 24 }}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        background: cardBg,
                                        border: `1px solid ${border}`,
                                        borderRadius: "14px",
                                        overflow: "hidden",
                                        transition: "box-shadow 0.2s",
                                        "&:hover": { boxShadow: "0 4px 20px rgba(59,130,246,0.15)" },
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        height="200"
                                        image={courseImage}
                                        sx={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '10px', borderRadius: 5 }}
                                    />

                                    <CardContent>
                                        <Stack spacing={2}>
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
                                                    <Typography variant="h5" fontWeight={700} color="#e5e7eb" fontFamily={interFont} letterSpacing="-0.02em">
                                                        ${completeCourseDet?.suggested_price}
                                                    </Typography>
                                                </Stack>
                                                {/* <Typography color="#D84D4D" fontSize={13} fontWeight="bold">
                                                    85% off
                                                </Typography> */}
                                            </Stack>

                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                {/* <Button
                                                    fullWidth
                                                    variant="contained"
                                                    disableElevation
                                                    sx={{
                                                        textTransform: "none",
                                                        fontFamily: interFont,
                                                        fontWeight: 600,
                                                        background: "#3b82f6",
                                                        py: 1.2,
                                                        color: "#3b82f6",
                                                        minHeight: 44,
                                                        borderRadius: "8px",
                                                        "&:hover": { background: "#2563eb" },
                                                    }}
                                                    onClick={handleBuyNow}
                                                >
                                                    {loadingCheckout ? <CircularProgress size={20} sx={{ color: "#3b82f6" }} /> : "Buy Now"}
                                                </Button> */}
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    disableElevation
                                                    disabled={isEnrolled}
                                                    sx={{
                                                        textTransform: "none",
                                                        fontFamily: interFont,
                                                        fontWeight: 600,
                                                        background: isEnrolled
                                                            ? "#6b7280"
                                                            : "#3b82f6",
                                                        py: 1.2,
                                                        color: "#ffffff",
                                                        minHeight: 44,
                                                        borderRadius: "8px",
                                                        "&:hover": {
                                                            background: isEnrolled
                                                                ? "#6b7280"
                                                                : "#2563eb"
                                                        },
                                                        filter: isEnrolled ? "blur(0.3px)" : "none",
                                                        pointerEvents: isEnrolled ? "none" : "auto",
                                                    }}
                                                    onClick={() => {
                                                        // if (completeCourseDet?.price_type === 'free') {
                                                        //     navigate(`/course/${createCourseSlug(
                                                        //         completeCourseDet.title,
                                                        //         completeCourseDet._id
                                                        //     )}`);

                                                        //     return;

                                                        // }

                                                        if (!studentEmail && completeCourseDet?.price_type === 'free') {
                                                            localStorage.setItem("selected_course_id", resolvedCourseId || courseId);
                                                            localStorage.setItem("redirectAfterLogin", "enroll");
                                                            localStorage.setItem("course_type", "free");
                                                            navigate("/signup", { state: { role: "student" } });
                                                            return;
                                                        }
                                                        else if (studentEmail && completeCourseDet?.price_type === 'free') {
                                                            navigate(`/course/${createCourseSlug(
                                                                completeCourseDet.title,
                                                                completeCourseDet._id
                                                            )}`);

                                                            return;
                                                        }

                                                        if (!isEnrolled) {

                                                            if (!studentEmail) {
                                                                localStorage.setItem("selected_course_id", resolvedCourseId || courseId);
                                                                localStorage.setItem("redirectAfterLogin", "checkout");

                                                                navigate("/signup", {
                                                                    state: {
                                                                        role: "student"
                                                                    }
                                                                });

                                                                return;
                                                            }

                                                            handleBuyNow();
                                                        }
                                                    }}
                                                >
                                                    {loadingCheckout ? (
                                                        <CircularProgress size={20} sx={{ color: "#ffffff" }} />
                                                    ) : isEnrolled ? (
                                                        "Enrolled"
                                                    ) : completeCourseDet?.price_type === 'free' ? ('View Course') : (
                                                        "Enroll Now"
                                                    )}
                                                </Button>
                                                {/* <Button
                                                    variant="outlined"
                                                    sx={{
                                                        borderColor: border,
                                                        minWidth: 44,
                                                        minHeight: 44,
                                                        px: 0,
                                                        borderRadius: "8px",
                                                        "&:hover": { borderColor: "#60a5fa", background: "rgba(59,130,246,0.08)" },
                                                    }}
                                                ><FavIcon /></Button> */}
                                            </Stack>

                                            <Divider sx={{ borderColor: "#21262d" }} />

                                            {/* <Typography fontWeight={700} color="#e5e7eb" fontFamily={interFont} fontSize={14}>
                                                This Course Includes
                                            </Typography> */}

                                            {/* <Stack spacing={1.2}>
                                                {[
                                                    "4h 33m on-demand video",
                                                    "10 downloadable resources",
                                                    "Access on both Mobile and PC",
                                                    "30 resourceful articles links",
                                                    "Certificate of completion"
                                                ].map((item, index) => (
                                                    <Stack key={item}
                                                        direction="row"
                                                        spacing={1.2}
                                                        alignItems="center">
                                                        <Box
                                                            sx={{
                                                                minWidth: 20,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                color: primary,
                                                            }}
                                                        >
                                                            {courseIncludesIco[index]}
                                                        </Box>
                                                        <Typography
                                                            fontSize={13}
                                                            fontFamily={interFont}
                                                            sx={{ color: "#9ca3af" }}
                                                        >
                                                            {item}
                                                        </Typography>
                                                    </Stack>
                                                ))}
                                            </Stack> */}
                                        </Stack>
                                    </CardContent>
                                </Paper>

                                {/* NEW: Course at a Glance */}
                                <Paper
                                    elevation={0}
                                    sx={{
                                        background: cardBg,
                                        border: `1px solid ${border}`,
                                        borderRadius: "14px",
                                        p: 2.5,
                                    }}
                                >
                                    <Typography fontWeight={700} mb={2} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                        Course at a Glance
                                    </Typography>

                                    <Box mb={2}>
                                        <Stack direction="row" justifyContent="space-between" mb={0.7}>
                                            <Typography fontSize={12.5} color="#9ca3af" fontFamily={interFont}>
                                                Progress
                                            </Typography>
                                            <Typography fontSize={12.5} color="#9ca3af" fontFamily={interFont}>
                                                0% Complete
                                            </Typography>
                                        </Stack>
                                        <LinearProgress
                                            variant="determinate"
                                            value={0}
                                            sx={{
                                                height: 6,
                                                borderRadius: 3,
                                                background: panelBg,
                                                "& .MuiLinearProgress-bar": { background: primary },
                                            }}
                                        />
                                    </Box>

                                    <Stack spacing={1.3}>
                                        {[
                                            { label: "Modules", value: totalSections },
                                            { label: "Lessons", value: totalLectures },
                                            { label: "Total Duration", value: displayDuration },
                                            { label: "Estimated Time / Module", value: estimatedTimePerModule },
                                            { label: "Level", value: completeCourseDet?.level || "Intermediate" },
                                        ].map((row) => (
                                            <Stack key={row.label} direction="row" justifyContent="space-between">
                                                <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                    {row.label}
                                                </Typography>
                                                <Typography fontSize={13} color="#e5e7eb" fontFamily={interFont} fontWeight={600}>
                                                    {row.value}
                                                </Typography>
                                            </Stack>
                                        ))}

                                        <Divider sx={{ borderColor: border, my: 0.5 }} />

                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <PersonOutlineOutlinedIcon sx={{ fontSize: 18, color: primary }} />
                                                <Typography fontSize={13} color="#9ca3af" fontFamily={interFont}>
                                                    Instructor
                                                </Typography>
                                            </Stack>
                                            <Typography fontSize={13} color="#e5e7eb" fontFamily={interFont} fontWeight={600}>
                                                {completeCourseDet?.user?.name || "Unknown"}
                                            </Typography>
                                        </Stack>

                                        <Typography
                                            fontSize={12.5}
                                            color={primary}
                                            fontFamily={interFont}
                                            sx={{ textDecoration: "underline", cursor: "pointer", textAlign: "right" }}
                                            onClick={handleViewProfile}
                                        >
                                            View Profile
                                        </Typography>
                                    </Stack>
                                </Paper>

                                {/* NEW: Digital Twin Assistant (sidebar chat widget) */}
                                {/* <Paper
                                    elevation={0}
                                    sx={{
                                        background: cardBg,
                                        border: `1px solid ${border}`,
                                        borderRadius: "14px",
                                        p: 2.5,
                                    }}
                                >
                                    <Stack direction="row" spacing={1} alignItems="center" mb={1.5}>
                                        <ChatBubbleOutlineOutlinedIcon sx={{ color: primary, fontSize: 20 }} />
                                        <Typography fontWeight={700} color="#e5e7eb" fontFamily={interFont} fontSize={15}>
                                            Digital Twin Assistant
                                        </Typography>
                                    </Stack>

                                    <Typography fontSize={13} color="#9ca3af" fontFamily={interFont} mb={2}>
                                        Hi! I'm your AI Digital Twin. I can help you understand the course, explain
                                        concepts, provide examples, and answer any questions you have.
                                    </Typography>

                                    {chatMessages.length > 0 && (
                                        <Stack spacing={1} mb={2} sx={{ maxHeight: 220, overflowY: "auto" }}>
                                            {chatMessages.map((m, idx) => (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        alignSelf: m.role === "user" ? "flex-end" : "flex-start",
                                                        background: m.role === "user" ? primary : panelBg,
                                                        border: m.role === "user" ? "none" : `1px solid ${border}`,
                                                        color: m.role === "user" ? "#fff" : "#9ca3af",
                                                        borderRadius: "10px",
                                                        px: 1.5,
                                                        py: 1,
                                                        fontSize: 12.5,
                                                        fontFamily: interFont,
                                                        maxWidth: "85%",
                                                    }}
                                                >
                                                    {m.text}
                                                </Box>
                                            ))}
                                            {chatLoading && (
                                                <Box sx={{ alignSelf: "flex-start" }}>
                                                    <CircularProgress size={16} sx={{ color: primary }} />
                                                </Box>
                                            )}
                                        </Stack>
                                    )}

                                    <Stack spacing={1} mb={2}>
                                        {quickAssistantQuestions.map((q) => (
                                            <Button
                                                key={q}
                                                fullWidth
                                                onClick={() => handleQuickQuestion(q)}
                                                sx={{
                                                    justifyContent: "flex-start",
                                                    textTransform: "none",
                                                    textAlign: "left",
                                                    fontFamily: interFont,
                                                    fontSize: 12.5,
                                                    color: primaryLight,
                                                    background: panelBg,
                                                    border: `1px solid ${border}`,
                                                    borderRadius: "8px",
                                                    py: 1,
                                                    "&:hover": { background: "#161b22", borderColor: primary },
                                                }}
                                            >
                                                {q}
                                            </Button>
                                        ))}
                                    </Stack>

                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Ask anything..."
                                            value={chatInput}
                                            onChange={(e) => setChatInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") handleSendChat();
                                            }}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    background: panelBg,
                                                    borderRadius: "8px",
                                                    color: "#e5e7eb",
                                                    fontFamily: interFont,
                                                    fontSize: 13,
                                                    "& fieldset": { borderColor: border },
                                                    "&:hover fieldset": { borderColor: primary },
                                                    "&.Mui-focused fieldset": { borderColor: primary },
                                                },
                                            }}
                                        />
                                        <IconButton size="small" sx={{ color: "#9ca3af" }}>
                                            <MicNoneOutlinedIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={handleSendChat}
                                            sx={{
                                                color: "#fff",
                                                background: primary,
                                                "&:hover": { background: "#2563eb" },
                                            }}
                                        >
                                            <SendOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Stack>
                                </Paper> */}
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}
